import tools from './tools';

// Turnstile component
export default function () {
    let root;
    let widgetId = null;
    let focusIntervalId = null;
    let retry = 0;
    let instantiated = false;

    return {
        get widgetId() {
            return widgetId;
        },

        get value() {
            return widgetId ? window.turnstile.getResponse(widgetId) : null;
        },

        init() {
            root = this.$root;

            if (this.isInModal) {
                this.instantiate();
            }
        },

        destroy() {
            try {
                window.turnstile.remove(widgetId);
                window.clearInterval(focusIntervalId);
            } catch (error) {}
        },

        instantiate() {
            if (retry > 10 || instantiated) return;

            if (!window.turnstile) {
                window.setTimeout(() => {
                    retry++;
                    this.instantiate();
                }, 100);

                return;
            }

            instantiated = true;

            widgetId = window.turnstile.render(root, {
                sitekey: root.dataset.sitekey,
                callback: (value) => {
                    root.nextElementSibling.value = value;
                    Helper.dispatchCustomEvent('revalidate', { attribute: tools.getName(root) });
                },
            });

            focusIntervalId = window.setInterval(() => {
                if (document.activeElement.isEqualNode(root.querySelector('iframe'))) {
                    root.classList.add('focus');
                } else {
                    root.classList.remove('focus');
                }
            }, 200);
        },
    };
}
